import { hasCookie, setCookie } from 'cookies-next'
import dayjs from 'dayjs'

/**
 * Get a cookie value by its key.
 */
export function getCookieValue(key: string): string | null {
  // Decode the entire document.cookie string, which contains all cookies.
  const decodedCookie = decodeURIComponent(document.cookie)

  // Split the decoded cookie string into an array of individual cookie strings.
  const cookieArray = decodedCookie.split(';')

  // Loop through the cookieArray to find the cookie with the specified key.
  for (let i = 0; i < cookieArray.length; i++) {
    let currentCookie = cookieArray[i]

    // Trim any leading or trailing whitespace from the current cookie string.
    currentCookie = currentCookie.trim()

    // Check if the current cookie string starts with the desired key followed by '='.
    if (currentCookie.indexOf(key + '=') === 0) {
      // If found, return the value by slicing the cookie string from the length of the key + 1.
      return currentCookie.substring(key.length + 1)
    }
  }

  // If the cookie with the specified key is not found, return null.
  return null
}

export const getStringArrayCookie = (name: string): string[] => {
  if (!hasCookie(name)) return []

  try {
    const cookieValue = getCookieValue(name) as string
    return JSON.parse(decodeURIComponent(cookieValue)) as string[]
  } catch (error) {
    console.error(`Error parsing cookie ${name}`, error)
    return []
  }
}

export const setStringArrayCookie = (name: string, value: string[], daysToExpire = 30): void => {
  const encodedValue = encodeURIComponent(JSON.stringify(value))
  setCookie(name, encodedValue, {
    expires: dayjs().add(daysToExpire, 'days').toDate(),
    path: '/',
  })
}

export const addToStringArrayCookie = (name: string, item: string, daysToExpire = 30): void => {
  const currentItems = getStringArrayCookie(name)
  if (!currentItems.includes(item)) {
    setStringArrayCookie(name, [...currentItems, item], daysToExpire)
  }
}

export const removeFromStringArrayCookie = (name: string, item: string, daysToExpire = 30): void => {
  const currentItems = getStringArrayCookie(name)
  if (currentItems.includes(item)) {
    setStringArrayCookie(
      name,
      currentItems.filter((i) => i !== item),
      daysToExpire,
    )
  }
}

export const hasInStringArrayCookie = (name: string, item: string): boolean => {
  return getStringArrayCookie(name).includes(item)
}
